/*
 * @Description:
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2025-12-18 13:26:15
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbGoods {
    /**
     * 查询商品列表
     */
    export var GetTbGoodsList = (body: any): Promise<any> => {
        return Get(`/api/TbGoods/GetTbGoodsList`, body);
    };
    /**
     * 查询商品列表合计
     */
    export var GetTbGoodsTotal = (body: any): Promise<any> => {
        return Get(`/api/TbGoods/GetTbGoodsTotal`, body);
    };
    /**
     * 新增商品V2
     */
    export var PostAddTbGoodsV2 = (body: any): Promise<any> => {
        return Post(`/api/TbGoods/PostAddTbGoodsV2`, body);
    };
    /**
     * 查询商品
     */
    export var GetTbGoodsById = (body: any): Promise<any> => {
        return Get(`/api/TbGoods/GetTbGoodsById`, body);
    };
    /**
     * 查看其它店铺库存
     */
    export var GetGoodsListByArticleNo = (body: any): Promise<any> => {
        return Get(`/api/TbGoods/GetGoodsListByArticleNo`, body);
    };
    /**
     * 批量修改商品上下架
     */
    export var PutUpdateTbGoodsIsShelves = (body: any): Promise<any> => {
        return Put(`/api/TbGoods/PutUpdateTbGoodsIsShelves`, body);
    };
    /**
     * 修改商品
     */
    export var PutUpdateTbGoods = (body: any): Promise<any> => {
        return Put(`/api/TbGoods/PutUpdateTbGoods`, body);
    };
    /**
     * 删除商品
     */
    export var DeleteTbGoods = (id: any): Promise<any> => {
        return Delete(`/api/TbGoods/DeleteTbGoods?id=${id}`, {});
    };
    /**
     * 库存查询列表
     */
    export var GetGoodsItemsList = (body: any): Promise<any> => {
        return Get(`/api/TbGoods/GetGoodsItemsList`, body);
    };
    /**
     * 库存查询列表_合计
     */
    export var GetGoodsItemsListForTotal = (body: any): Promise<any> => {
        return Get(`/api/TbGoods/GetGoodsItemsListForTotal`, body);
    };

    /**
     * 盘点商品
     */
    export var PostUpdateInventoryCount = (body: any): Promise<any> => {
        return Post(`/api/TbGoods/PostUpdateInventoryCount`, body);
    };

    /**
     * 调拨查询商品列表
     */
    export var GetGoodsList = (body: any): Promise<any> => {
        return Get(`/api/TbGoods/GetGoodsList`, body);
    };
    /**
     * 根据条码查询商品
     */
    export var GetTbGoodsByBarCode = (body: any): Promise<any> => {
        return Get(`/api/TbGoods/GetTbGoodsByBarCodeV2`, body);
    };
    /**
     * 根据条码查询商品V3
     */
    export var GetTbGoodsByBarCodeV3 = (body: any): Promise<any> => {
        return Get(`/api/TbGoods/GetTbGoodsByBarCodeV3`, body);
    };

    /**
     * 商品条码查询
     */
     export var BarCodeQuery = (body: any): Promise<any> => {
        return Get(`/api/TbGoods/BarCodeQueryV2`, body);
    };
    /**
     * 同步商品库存
     */
     export var GoodsSyncTotalStock = (body: any): Promise<any> => {
        return Post(`/api/TbGoods/GoodsSyncTotalStock`, body);
    };
    /**
     * 根据商品主体ID批量查询商品子项状态和库存
     */
     export var PostGoodsItemsByIds = (body: any): Promise<any> => {
        return Post(`/api/TbGoods/PostGoodsItemsByIds`, body);
    };
}



// WEBPACK FOOTER //
// ./src/http/api_TbGoods.ts